module.exports = __webpack_public_path__ + "img/0x1A2fb0Af670D0234c2857FaD35b789F8Cb725584.ba0745b5.png";